export function PathNodeIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4645 3.53554C13.4171 1.58291 16.5829 1.58291 18.5355 3.53553L26.4645 11.4645C28.4171 13.4171 28.4171 16.5829 26.4645 18.5355L18.5355 26.4645C16.5829 28.4171 13.4171 28.4171 11.4645 26.4645L3.53554 18.5355C1.58291 16.5829 1.58291 13.4171 3.53553 11.4645L11.4645 3.53554Z"
        fill="#CDE4E1"
      />
      <path
        d="M15.0098 21.25C15.7001 21.25 16.2598 20.6904 16.2598 20C16.2598 19.3096 15.7001 18.75 15.0098 18.75C14.3194 18.75 13.7598 19.3096 13.7598 20C13.7598 20.6904 14.3194 21.25 15.0098 21.25Z"
        fill="#2D2E2E"
      />
      <path
        d="M15.3599 9.13C14.1799 9.12 13.1699 9.43 12.3799 9.8V11.78C12.9999 11.38 14.0299 10.88 15.2999 10.88C15.3199 10.88 15.3299 10.88 15.3499 10.88C16.6499 10.89 17.4199 11.6 17.4899 12.26C17.5699 13.14 16.5299 13.93 14.8399 14.27L14.1399 14.41L14.1499 17.49H15.8999V15.81C18.5399 15.05 19.3699 13.43 19.2399 12.08C19.0599 10.4 17.4299 9.15 15.3599 9.13Z"
        fill="#2D2E2E"
      />
    </svg>
  );
}
